/*
 * @Description:
 * @Date: 2024-11-29 11:37:12
 */
import appStore from '@/store';
import { storeToRefs } from 'pinia';
import { RouteLocationNormalized } from 'vue-router';
import { LOGIN_PAGE_PATH } from '@constants/system';
import { XrkMessage } from 'xrk-components';
export default async (to: RouteLocationNormalized, next) => {
  const { menuUrls } = storeToRefs(appStore.useMenuStoreSetup);
  // 无菜单
  if (!menuUrls.value?.length) {
    appStore.useUserStoreSetup.clearUser();
    XrkMessage.error('该账号无菜单，请联系管理员！');
    next('/login');
    return Promise.reject('无菜单权限！');
  }
  // 匹配异常
  if (!to.matched.length) {
    console.error('菜单不匹配！');
  }
  // 已登录并在登录页进行重定向，无path重定向
  if (to.path === LOGIN_PAGE_PATH || to.path === '/') {
    appStore.useMenuStoreSetup.routeForMenu(menuUrls.value[0]);
    next(menuUrls.value[0]);
    return Promise.reject('登录重定向');
  }
  // 设置当前菜单数据
  appStore.useMenuStoreSetup.routeForMenu(to.path);
  // 如企业认证页面、详情页面不需要去菜单匹配
  if (
    menuUrls.value.includes(to.meta.parentPath || to.path) ||
    to.meta.noLayout ||
    to.meta.isMenuSkip
  ) {
    return Promise.resolve();
  } else {
    next(menuUrls.value[0]);
    return Promise.reject('无菜单权限重定向');
  }
};
